import {
	deleteObject,
	getDownloadURL,
	getMetadata,
	ref,
	uploadBytes,
} from '@firebase/storage';

import type { FirebaseStorage } from 'firebase/storage';
import type { StorageReference } from '@firebase/storage';

class FirebaseStorageHandler {
	constructor(private readonly storage: FirebaseStorage) {}

	async getStorage() {
		return this.storage;
	}

	async uploadBytes(path: string, file: File) {
		const storageRef = ref(this.storage, `${path}/${file.name}`);
		await uploadBytes(storageRef, file);

		return this.getDownloadURL(storageRef);
	}

	async getDownloadURL(storageRef: StorageReference) {
		return getDownloadURL(storageRef);
	}

	async deleteFile(path: string) {
		const storageRef = ref(this.storage, path);
		await deleteObject(storageRef);
	}

	async fileExists(path: string): Promise<boolean> {
		try {
			const storageRef = ref(this.storage, path);
			await getMetadata(storageRef);

			return true;
		}
		catch (error) {
			return false;
		}
	}
}

export default FirebaseStorageHandler;